(function() {
       var modal = document.getElementById('videoModal');
       var nativeVid = document.getElementById('videoModalNative');
       var iframe = document.getElementById('videoModalFrame');
       // Products without video media do not render the modal video player
       // (nor the main-stage .main-video/.main-iframe). Bail out early so we
       // never touch elements that intentionally aren't in the DOM — this is
       // also what keeps Google's video crawler from finding empty <video>
       // placeholders on image-only PDPs ("video not on a watch page").
       if (!modal || !nativeVid || !iframe) { return; }
       var backdrop = modal.querySelector('.video-modal__backdrop');
       var closeBtn = modal.querySelector('.video-modal__close');
       var sidebar = document.getElementById('videoModalSidebar');
       var listEl = document.getElementById('videoModalList');
       var infoEl = document.getElementById('videoModalInfo');
       var playOverlay = document.getElementById('videoPlayOverlay');
      var productTitle = window.__PI_CFG.title;
       var productVendor = window.__PI_CFG.vendor;

       // Play overlay logic – Amazon style: only play button, hidden when playing
       function updateOverlay(playing) {
         if (playing) {
           playOverlay.classList.add('is-playing');
         } else {
           playOverlay.classList.remove('is-playing');
         }
       }
       playOverlay.addEventListener('click', function() {
         if (nativeVid.classList.contains('is-active')) {
           nativeVid.play().catch(function(){});
         } else if (iframe.classList.contains('is-active') && iframe.contentWindow) {
           try {
             iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
             iframe.contentWindow.postMessage('{"method":"play"}', '*');
             updateOverlay(true);
           } catch(e) {}
         }
       });
       nativeVid.addEventListener('play', function() { updateOverlay(true); });
       nativeVid.addEventListener('pause', function() { updateOverlay(false); });
       nativeVid.addEventListener('ended', function() { updateOverlay(false); });

       // Tab switching
       modal.querySelectorAll('.video-modal__tab').forEach(function(tab) {
         tab.addEventListener('click', function() {
           var target = this.getAttribute('data-tab');
           modal.querySelectorAll('.video-modal__tab').forEach(function(t) { t.classList.remove('is-active'); });
           modal.querySelectorAll('.video-modal__panel').forEach(function(p) { p.classList.remove('is-active'); });
           this.classList.add('is-active');
           modal.querySelector('[data-panel="' + target + '"]').classList.add('is-active');
           // Pause video if switching to images, resume if switching back
           if (target === 'bilder') {
             nativeVid.pause && nativeVid.pause();
             // Pause YouTube/Vimeo iframe via postMessage
             if (iframe.classList.contains('is-active') && iframe.contentWindow) {
               try {
                 iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                 iframe.contentWindow.postMessage('{"method":"pause"}', '*');
               } catch(e) {}
             }
           } else if (target === 'videos') {
             // Resume native video from where it stopped
             if (nativeVid.classList.contains('is-active') && nativeVid.src) {
               nativeVid.play().catch(function(){});
             }
             // Resume YouTube/Vimeo iframe via postMessage
             if (iframe.classList.contains('is-active') && iframe.contentWindow) {
               try {
                 iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                 iframe.contentWindow.postMessage('{"method":"play"}', '*');
               } catch(e) {}
             }
           }
         });
       });

       // Lazy collect video items (gallery thumbs may not be ready at script load)
       var videoItems = [];
       function getVideoPosterFallback() {
         var firstImageThumb = document.querySelector('.thumb-item[data-type="image"]');
         if (!firstImageThumb) return '';
         return firstImageThumb.getAttribute('data-src') || (firstImageThumb.querySelector('img') ? firstImageThumb.querySelector('img').src : '');
       }

       function updateSidebarThumb(idx, src) {
         if (!src) return;
         listEl.querySelectorAll('.video-modal__list-item[data-video-idx="' + idx + '"] img').forEach(function(img) {
           img.src = src;
         });
       }

       function tryGenerateAutoPoster(v, idx, onDone) {
         if (!v || v.type !== 'video' || !v.video) {
           onDone && onDone('');
           return;
         }
         if (v._autoPosterTried) {
           onDone && onDone(v._autoPoster || '');
           return;
         }
         v._autoPosterTried = true;

         var probe = document.createElement('video');
         var done = false;
         var timeoutId = setTimeout(function() {
           finalize('');
         }, 3000);

         function finalize(result) {
           if (done) return;
           done = true;
           clearTimeout(timeoutId);
           try {
             probe.pause();
             probe.removeAttribute('src');
             probe.load();
           } catch(e) {}
           v._autoPoster = result || '';
           onDone && onDone(v._autoPoster);
         }

         probe.muted = true;
         probe.playsInline = true;
         probe.preload = 'auto';
         probe.crossOrigin = 'anonymous';

         probe.addEventListener('error', function() {
           finalize('');
         }, { once: true });

         probe.addEventListener('loadeddata', function() {
           try {
             var seekTo = 1.2;
             if (isFinite(probe.duration) && probe.duration > 0) {
               seekTo = Math.min(2.5, Math.max(0.4, probe.duration * 0.25));
             }
             probe.currentTime = seekTo;
           } catch(e) {
             finalize('');
           }
         }, { once: true });

         probe.addEventListener('seeked', function() {
           try {
             var w = probe.videoWidth || 0;
             var h = probe.videoHeight || 0;
             if (!w || !h) {
               finalize('');
               return;
             }

             var maxW = 960;
             var outW = Math.min(w, maxW);
             var outH = Math.round((h / w) * outW);

             var canvas = document.createElement('canvas');
             canvas.width = outW;
             canvas.height = outH;

             var ctx = canvas.getContext('2d');
             if (!ctx) {
               finalize('');
               return;
             }

             ctx.drawImage(probe, 0, 0, outW, outH);
             var dataUrl = canvas.toDataURL('image/jpeg', 0.82);
             finalize(dataUrl);
           } catch(e) {
             finalize('');
           }
         }, { once: true });

         try {
           probe.src = v.video;
           probe.load();
         } catch(e) {
           finalize('');
         }
       }

       function collectVideoItems() {
         videoItems = [];
         var fallbackPoster = getVideoPosterFallback();
         document.querySelectorAll('.thumb-item[data-type="video"], .thumb-item[data-type="external_video"]').forEach(function(t) {
           var img = t.querySelector('img');
           var src = t.getAttribute('data-src') || (img ? img.src : '');
           var poster = t.getAttribute('data-poster') || src || fallbackPoster;
           videoItems.push({
             type: t.getAttribute('data-type'),
             video: t.getAttribute('data-video'),
             videoSources: t.getAttribute('data-video-sources'),
             src: src,
             poster: poster,
             alt: img ? img.alt : '',
             created: t.getAttribute('data-created') || '',
             index: parseInt(t.getAttribute('data-index'), 10)
           });
         });
         console.log('[VideoModal] Collected', videoItems.length, 'video items');
       }

       var currentVideoIdx = 0;

       function buildSidebar() {
         sidebar.style.display = '';
         listEl.innerHTML = '';
         videoItems.forEach(function(v, i) {
           var item = document.createElement('div');
           item.className = 'video-modal__list-item' + (i === currentVideoIdx ? ' is-active' : '');
           item.setAttribute('data-video-idx', i);
           item.innerHTML =
             '<div class="video-modal__list-thumb">' +
               '<img src="' + (v.poster || v.src) + '" alt="' + (v.alt || productTitle).replace(/"/g,'&quot;') + '" loading="lazy" width="120" height="68">' +
               '<span class="video-modal__list-thumb-play"><i class="fa-solid fa-play"></i></span>' +
             '</div>' +
             '<div class="video-modal__list-info">' +
               '<span class="video-modal__list-title">' + (v.alt || productTitle) + '</span>' +
               '<span class="video-modal__list-vendor">' + productVendor + '</span>' +
             '</div>';
           item.addEventListener('click', function() { playVideo(i); });
           listEl.appendChild(item);

           if (!v.poster) {
             tryGenerateAutoPoster(v, i, function(generated) {
               if (!generated) return;
               updateSidebarThumb(i, generated);
               if (i === currentVideoIdx && nativeVid.classList.contains('is-active')) {
                 nativeVid.setAttribute('poster', generated);
               }
             });
           }
         });
       }

       function playVideo(idx) {
         currentVideoIdx = idx;
         var v = videoItems[idx];
         // Reset overlay
         updateOverlay(false);
         // Reset both — clear inline display and use classes only
         nativeVid.pause && nativeVid.pause();
         nativeVid.removeAttribute('src');
         iframe.removeAttribute('src');
         nativeVid.classList.remove('is-active');
         iframe.classList.remove('is-active');
         nativeVid.style.removeProperty('display');
         iframe.style.removeProperty('display');

         if (v.type === 'video') {
           var posterSrc = v.poster || v.src || getVideoPosterFallback();
           if (posterSrc) nativeVid.setAttribute('poster', posterSrc);
           else nativeVid.removeAttribute('poster');

           if (!v.poster) {
             tryGenerateAutoPoster(v, idx, function(generated) {
               if (!generated) return;
               updateSidebarThumb(idx, generated);
               if (currentVideoIdx === idx && nativeVid.classList.contains('is-active')) {
                 nativeVid.setAttribute('poster', generated);
               }
             });
           }

           // Clear old sources
           while (nativeVid.firstChild) nativeVid.removeChild(nativeVid.firstChild);
           nativeVid.removeAttribute('src');
           // Add all sources — sorted: MP4 first (Safari), then WebM (Chrome/FF)
           var sources = [];
           try { sources = JSON.parse(v.videoSources || '[]'); } catch(e) {}
           if (sources.length > 0) {
             sources.sort(function(a, b) {
               var aMP4 = (a.type || '').indexOf('mp4') > -1 ? 0 : 1;
               var bMP4 = (b.type || '').indexOf('mp4') > -1 ? 0 : 1;
               return aMP4 - bMP4;
             });
             sources.forEach(function(s) {
               var sourceEl = document.createElement('source');
               sourceEl.src = s.url;
               if (s.type) sourceEl.type = s.type;
               nativeVid.appendChild(sourceEl);
             });
           } else {
             nativeVid.src = v.video;
           }
           nativeVid.classList.add('is-active');
           nativeVid.load();
           nativeVid.play().catch(function(){});
         } else {
           var url = v.video;
           if (url.indexOf('youtube') > -1) {
             url = url.replace('autoplay=0', 'autoplay=1');
             if (url.indexOf('enablejsapi') === -1) {
               url += (url.indexOf('?') > -1 ? '&' : '?') + 'enablejsapi=1';
             }
           } else if (url.indexOf('vimeo.com') > -1) {
             url = url.replace('autoplay=0', 'autoplay=1');
           }
           iframe.src = url;
           iframe.classList.add('is-active');
           // Autoplay → mark overlay as playing after small delay
           setTimeout(function() { updateOverlay(true); }, 500);
         }
         // Update sidebar active
         listEl.querySelectorAll('.video-modal__list-item').forEach(function(el, i) {
           el.classList.toggle('is-active', i === idx);
         });
       }

       window.openVideoModal = function(galleryIndex) {
         // Collect items fresh each time (thumbs may not exist at script load)
         collectVideoItems();
         if (videoItems.length === 0) {
           console.warn('[VideoModal] No video items found');
           return;
         }
         var idx = 0;
         for (var i = 0; i < videoItems.length; i++) {
           if (videoItems[i].index === galleryIndex) { idx = i; break; }
         }
         // Reset to videos tab
         modal.querySelectorAll('.video-modal__tab').forEach(function(t) { t.classList.remove('is-active'); });
         modal.querySelectorAll('.video-modal__panel').forEach(function(p) { p.classList.remove('is-active'); });
         modal.querySelector('[data-tab="videos"]').classList.add('is-active');
         modal.querySelector('[data-panel="videos"]').classList.add('is-active');

         buildSidebar();
         modal.classList.add('is-open');
         modal.setAttribute('aria-hidden', 'false');
         document.body.style.overflow = 'hidden';
         playVideo(idx);
       };

       window.closeVideoModal = function() {
         modal.classList.remove('is-open');
         modal.setAttribute('aria-hidden', 'true');
         document.body.style.overflow = '';
         nativeVid.pause && nativeVid.pause();
         nativeVid.removeAttribute('src');
         iframe.removeAttribute('src');
         nativeVid.classList.remove('is-active');
         iframe.classList.remove('is-active');
       };

       backdrop.addEventListener('click', window.closeVideoModal);
       closeBtn.addEventListener('click', window.closeVideoModal);
       document.addEventListener('keydown', function(e) {
         if (e.key === 'Escape' && modal.classList.contains('is-open')) {
           window.closeVideoModal();
         }
       });

       // Bilder panel: thumbnail click → switch main image
       modal.querySelectorAll('.bilder-thumb').forEach(function(thumb) {
         thumb.addEventListener('click', function() {
           var idx = this.getAttribute('data-bilder-idx');
           // Update active thumb
           modal.querySelectorAll('.bilder-thumb').forEach(function(t) { t.classList.remove('is-active'); });
           this.classList.add('is-active');
           // Update active image
           modal.querySelectorAll('.bilder-main__img').forEach(function(img) {
             img.classList.toggle('is-active', img.getAttribute('data-bilder-index') === idx);
           });
         });
       });

       var shareBtn       = document.getElementById('videoShareBtn');
       var shareCountEl   = document.getElementById('videoShareCount');

       function setShareCount(n) {
         shareCountEl.textContent = n;
         shareCountEl.style.display = n > 0 ? '' : 'none';
       }

       var shareBackdrop = document.createElement('div');
       shareBackdrop.id = 'kxShareBackdrop';
       document.body.appendChild(shareBackdrop);

       var waIcon = '<svg width="26" height="26" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

       var sharePanel = document.createElement('div');
       sharePanel.id = 'kxSharePanel';
       sharePanel.innerHTML =
         '<div class="kx-share-panel__header">' +
           '<span class="kx-share-panel__title">' + (((window.KX_PDP_I18N||{}).share) || 'Teilen') + '</span>' +
           '<button class="kx-share-panel__close" aria-label="' + (((window.KX_PDP_I18N||{}).close) || 'Schließen') + '">×</button>' +
         '</div>' +
         '<div class="kx-share-panel__options">' +

           '<a class="kx-share-option kx-share-option--wa" id="kxShareWa" href="#" target="_blank" rel="noopener" aria-label="Auf WhatsApp teilen">' +
             '<span class="kx-share-option__icon">' + waIcon + '</span><span>WhatsApp</span>' +
           '</a>' +
           '<a class="kx-share-option kx-share-option--fb" id="kxShareFb" href="#" target="_blank" rel="noopener" aria-label="Auf Facebook teilen">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg></span><span>Facebook</span>' +
           '</a>' +
           '<a class="kx-share-option kx-share-option--x" id="kxShareX" href="#" target="_blank" rel="noopener" aria-label="Auf X teilen">' +
             '<span class="kx-share-option__icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.259 5.633L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></span><span>X</span>' +
           '</a>' +
           '<a class="kx-share-option kx-share-option--mail" id="kxShareMail" href="#" aria-label="Per E-Mail teilen">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></span><span>E-Mail</span>' +
           '</a>' +
           '<a class="kx-share-option kx-share-option--pin" id="kxSharePin" href="#" target="_blank" rel="noopener" aria-label="Auf Pinterest teilen">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg></span><span>Pinterest</span>' +
           '</a>' +

           '<a class="kx-share-option kx-share-option--li" id="kxShareLi" href="#" target="_blank" rel="noopener" aria-label="Auf LinkedIn teilen">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg></span><span>LinkedIn</span>' +
           '</a>' +
           '<button class="kx-share-option kx-share-option--ig" id="kxShareIg">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg></span><span>Instagram</span>' +
           '</button>' +
           '<button class="kx-share-option kx-share-option--tt" id="kxShareTt">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.34 6.34 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/></svg></span><span>TikTok</span>' +
           '</button>' +
           '<button class="kx-share-option kx-share-option--embed" id="kxShareEmbed">' +
             '<span class="kx-share-option__icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg></span><span>Einbetten</span>' +
           '</button>' +
         '</div>' +
         '<div class="kx-share-panel__divider"></div>' +
         '<div class="kx-share-panel__link-row">' +
           '<span class="kx-share-panel__link-url" id="kxShareUrl"></span>' +
           '<button class="kx-share-panel__copy-btn" id="kxShareCopyBtn">Kopieren</button>' +
         '</div>' +
         '<div id="kxEmbedView">' +
           '<p class="kx-embed-title">Einbettungscode:</p>' +
           '<div class="kx-embed-code" id="kxEmbedCode"></div>' +
           '<button id="kxEmbedCopyBtn">Code kopieren</button>' +
         '</div>';
       document.body.appendChild(sharePanel);

       var shareToast = document.createElement('div');
       shareToast.id = 'kxShareToast';
       document.body.appendChild(shareToast);

       function showToast(msg) {
         shareToast.textContent = msg;
         shareToast.classList.add('is-visible');
         setTimeout(function() { shareToast.classList.remove('is-visible'); }, 2200);
       }

       function getEmbedCode(pageUrl) {
         var v = videoItems[currentVideoIdx];
         if (!v) return '';
         if (v.type === 'external_video' && v.video.indexOf('youtube') > -1) {

           var yid = v.video.replace(/.*\/embed\/([^?]+).*/,'$1');
           return '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + yid + '" frameborder="0" loading="lazy" allowfullscreen></iframe>';
         } else if (v.type === 'external_video' && v.video.indexOf('vimeo.com') > -1) {
           var vid2 = v.video.replace(/.*\/video\/([^?]+).*/,'$1');
           return '<iframe width="560" height="315" src="https://player.vimeo.com/video/' + vid2 + '" frameborder="0" loading="lazy" allowfullscreen></iframe>';
         }
         return '<a href="' + pageUrl + '">' + document.title + '</a>';
       }

       function openSharePanel(url) {
         var enc  = encodeURIComponent(url);
         var ttl  = encodeURIComponent(document.title);
         document.getElementById('kxShareUrl').textContent = url;
         document.getElementById('kxShareWa').href  = 'https://api.whatsapp.com/send?text=' + enc;
         document.getElementById('kxShareFb').href  = 'https://www.facebook.com/sharer/sharer.php?u=' + enc;
         document.getElementById('kxShareX').href   = 'https://twitter.com/intent/tweet?url=' + enc + '&text=' + ttl;
         var emailBody = 'Hallo,%0A%0AIch m%C3%B6chte dir dieses Produkt empfehlen:%0A%0A' + ttl + '%0A%0A' + enc + '%0A%0AViele%20Gr%C3%BC%C3%9Fe';
         document.getElementById('kxShareMail').href= 'mailto:?subject=' + ttl + '&body=' + emailBody;
         document.getElementById('kxSharePin').href = 'https://pinterest.com/pin/create/button/?url=' + enc + '&description=' + ttl;
         document.getElementById('kxShareLi').href  = 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc;
         document.getElementById('kxEmbedView').classList.remove('is-open');
         document.getElementById('kxEmbedCode').textContent = '';
         sharePanel.classList.add('is-open');
         shareBackdrop.classList.add('is-open');
       }

       function closeSharePanel() {
         sharePanel.classList.remove('is-open');
         shareBackdrop.classList.remove('is-open');
       }

       function copyText(text, msg) {
         if (navigator.clipboard) {
           navigator.clipboard.writeText(text).then(function() { showToast(msg); }).catch(function() {});
         } else {
           var ta = document.createElement('textarea');
           ta.value = text; ta.style.position='fixed'; ta.style.opacity='0';
           document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
           showToast(msg);
         }
       }

       shareBackdrop.addEventListener('click', closeSharePanel);
       sharePanel.querySelector('.kx-share-panel__close').addEventListener('click', closeSharePanel);

       function recordShare() {
         var vid = videoId();
         var current = prefetchStore[vid] || getCached(vid) || { views: 0, likes: 0, dislikes: 0, shares: 0, myAction: '' };
         var newShares = (current.shares || 0) + 1;
         setShareCount(newShares);
         animCount(shareCountEl);
         if (current) { current.shares = newShares; prefetchStore[vid] = current; setCache(vid, current); }
         apiCall('share', vid, function(data) {
           var serverShares = data.shares !== undefined ? data.shares : newShares;
           setShareCount(serverShares);
           data.shares = serverShares;
           prefetchStore[vid] = data; setCache(vid, data);
         });
       }

       ['kxShareWa','kxShareFb','kxShareX','kxShareMail','kxSharePin','kxShareLi'].forEach(function(id) {
         document.getElementById(id).addEventListener('click', function() { recordShare(); });
       });

       document.getElementById('kxShareCopyBtn').addEventListener('click', function() {
         copyText(document.getElementById('kxShareUrl').textContent, ((window.KX_PDP_I18N||{}).linkCopied) || 'Link kopiert!');
         recordShare();
         closeSharePanel();
       });

       document.getElementById('kxShareIg').addEventListener('click', function() {
         copyText(document.getElementById('kxShareUrl').textContent, ((window.KX_PDP_I18N||{}).linkCopiedIg) || 'Link kopiert! Jetzt in Instagram einfügen.');
         window.open('https://www.instagram.com/', '_blank');
         recordShare();
         closeSharePanel();
       });

       document.getElementById('kxShareTt').addEventListener('click', function() {
         copyText(document.getElementById('kxShareUrl').textContent, ((window.KX_PDP_I18N||{}).linkCopiedTt) || 'Link kopiert! Jetzt in TikTok einfügen.');
         window.open('https://www.tiktok.com/', '_blank');
         recordShare();
         closeSharePanel();
       });

       document.getElementById('kxShareEmbed').addEventListener('click', function() {
         var url = document.getElementById('kxShareUrl').textContent;
         var code = getEmbedCode(url);
         document.getElementById('kxEmbedCode').textContent = code;
         document.getElementById('kxEmbedView').classList.toggle('is-open');
       });
       document.getElementById('kxEmbedCopyBtn').addEventListener('click', function() {
         copyText(document.getElementById('kxEmbedCode').textContent, ((window.KX_PDP_I18N||{}).embedCopied) || 'Einbettungscode kopiert!');
         closeSharePanel();
       });

       shareBtn.addEventListener('click', function() {
         var url = window.location.href.split('#')[0];
         openSharePanel(url);
         popBtn(shareBtn);
       });

       var VIDEO_ENGAGEMENT_API = 'https://script.google.com/macros/s/AKfycbzRAE7_bK9_m1-nEhAfpHVmsDqHkqCmR-qSMlkSLc8F8_k61H-scIQiMUnNXdYZnUHnYQ/exec';
       var viewsEl = document.getElementById('videoModalViews');
       var likeBtn = document.getElementById('videoLikeBtn');
       var dislikeBtn = document.getElementById('videoDislikeBtn');
       var likeCountEl = document.getElementById('videoLikeCount');
       var dislikeCountEl = document.getElementById('videoDislikeCount');
       var publishDateEl = document.getElementById('videoPublishDate');
       var CACHE_KEY = 'kx_vid_cache';
       // Einwilligung (02.10.2026): Aufrufe/Likes gehen mit einer dauerhaften
       // Besucher-ID (kx_visitor_id) an Google Apps Script. Das ist Statistik und
       // laeuft nur nach Einwilligung (window.kxConsent, snippets/kx-cookiebot.liquid).
       function engagementAllowed() {
         return !!(window.kxConsent && window.kxConsent.service('analytics.video_stats'));
       }

       function timeAgo(iso) {
         if (!iso) return '';

         var s = String(iso).trim();

         var datePart = s.slice(0, 10);
         var d = new Date(datePart + 'T00:00:00');
         if (isNaN(d.getTime())) return '';
         var diff = Math.floor((Date.now() - d) / 1000);
         if (diff < 0)        return 'Gerade hochgeladen';
         if (diff < 86400)    return 'Heute';
         if (diff < 2592000)  return 'Vor ' + Math.floor(diff / 86400)   + ' Tagen';
         if (diff < 31536000) return 'Vor ' + Math.floor(diff / 2592000) + ' Monaten';
         return 'Vor ' + Math.floor(diff / 31536000) + ' Jahren';
       }

       var prefetchStore = {};
       var prefetchDone  = {};

       function getCached(vid) {
         try { var c = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}'); return c[vid] || null; } catch(e) { return null; }
       }
       function setCache(vid, data) {
         if (!engagementAllowed()) return;
         try {
           var c = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');

           if (data.shares === undefined && c[vid] && c[vid].shares) data.shares = c[vid].shares;
           c[vid] = data;
           localStorage.setItem(CACHE_KEY, JSON.stringify(c));
         } catch(e) {}
       }

       function getVisitorId() {
         var id = localStorage.getItem('kx_visitor_id');
         if (!id) {
           id = 'v_' + Math.random().toString(36).substr(2,12) + '_' + Date.now();
           localStorage.setItem('kx_visitor_id', id);
         }
         return id;
       }

       function videoId() {
         var v = videoItems[currentVideoIdx];
         return v ? (v.video || '').replace(/[^a-zA-Z0-9_-]/g,'').slice(0,80) : '';
       }

       function vidKey(v) {
         return v ? (v.video || '').replace(/[^a-zA-Z0-9_-]/g,'').slice(0,80) : '';
       }

       function formatViews(n) {
         if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0','') + ' Mio.';
         if (n >= 1000) return (n / 1000).toFixed(1).replace('.0','') + ' Tsd.';
         return n.toLocaleString('de-DE');
       }

       function renderEngagement(data) {
         var vid = videoId();
         var prev = prefetchStore[vid] || getCached(vid) || {};

         var shares = data.shares !== undefined ? data.shares : (prev.shares || 0);
         viewsEl.textContent = formatViews(data.views || 0) + ' Aufrufe';
         likeCountEl.textContent = data.likes || 0;
         dislikeCountEl.textContent = data.dislikes || 0;
         setShareCount(shares);
         likeBtn.classList.toggle('is-active', data.myAction === 'like');
         dislikeBtn.classList.toggle('is-active', data.myAction === 'dislike');
         data.shares = shares;
         prefetchStore[vid] = data;
         setCache(vid, data);
       }

       function apiCall(action, vid, cb) {
         if (!vid || !VIDEO_ENGAGEMENT_API || !engagementAllowed()) return;
         var url = VIDEO_ENGAGEMENT_API + '?action=' + action
           + '&vid=' + encodeURIComponent(vid)
           + '&uid=' + encodeURIComponent(getVisitorId());
         fetch(url)
           .then(function(r) { return r.json(); })
           .then(function(data) { if (cb) cb(data); })
           .catch(function() {});
       }

       function prefetchAll() {
         if (!VIDEO_ENGAGEMENT_API || !engagementAllowed()) return;

         collectVideoItems();
         videoItems.forEach(function(v) {
           var key = vidKey(v);
           if (!key || prefetchDone[key]) return;
           prefetchDone[key] = true;

           var url = VIDEO_ENGAGEMENT_API + '?action=get'
             + '&vid=' + encodeURIComponent(key)
             + '&uid=' + encodeURIComponent(getVisitorId());
           fetch(url)
             .then(function(r) { return r.json(); })
             .then(function(data) {
               var prev = prefetchStore[key] || getCached(key) || {};
               if (data.shares === undefined) data.shares = prev.shares || 0;
               prefetchStore[key] = data;
               setCache(key, data);
             })
             .catch(function() {});
         });
       }

       if (window.kxConsent) window.kxConsent.on('statistics', prefetchAll);

       function initEngagement() {
         var vid = videoId();

         var v = videoItems[currentVideoIdx];
         if (publishDateEl) {
           publishDateEl.textContent = (v && v.created) ? timeAgo(v.created) : '';
         }

         if (prefetchStore[vid]) {
           renderEngagement(prefetchStore[vid]);

           apiCall('view', vid, function(data) { renderEngagement(data); });
           return;
         }

         var cached = getCached(vid);
         if (cached) renderEngagement(cached);

         if (!prefetchDone[vid]) prefetchAll();
         apiCall('view', vid, function(data) { renderEngagement(data); });
       }

       var _engagementSeq = 0;

       function popBtn(btn) {
         btn.classList.remove('kx-pop');
         void btn.offsetWidth;
         btn.classList.add('kx-pop');
         btn.addEventListener('animationend', function h() {
           btn.classList.remove('kx-pop');
           btn.removeEventListener('animationend', h);
         });
       }

       function animCount(el) {
         el.classList.remove('kx-count-anim');
         void el.offsetWidth;
         el.classList.add('kx-count-anim');
         el.addEventListener('animationend', function h() {
           el.classList.remove('kx-count-anim');
           el.removeEventListener('animationend', h);
         });
       }

       function optimisticReact(action) {
         var seq = ++_engagementSeq;
         var vid = videoId();
         var current = prefetchStore[vid] || getCached(vid) || { views: 0, likes: 0, dislikes: 0, shares: 0, myAction: '' };
         var optimistic = { views: current.views, likes: current.likes, dislikes: current.dislikes, shares: current.shares || 0, myAction: current.myAction };

         if (action === 'like') {
           if (optimistic.myAction === 'like') {
             optimistic.likes = Math.max(0, optimistic.likes - 1);
             optimistic.myAction = '';
           } else {
             if (optimistic.myAction === 'dislike') optimistic.dislikes = Math.max(0, optimistic.dislikes - 1);
             optimistic.likes += 1;
             optimistic.myAction = 'like';
           }
           popBtn(likeBtn);
         } else {
           if (optimistic.myAction === 'dislike') {
             optimistic.dislikes = Math.max(0, optimistic.dislikes - 1);
             optimistic.myAction = '';
           } else {
             if (optimistic.myAction === 'like') optimistic.likes = Math.max(0, optimistic.likes - 1);
             optimistic.dislikes += 1;
             optimistic.myAction = 'dislike';
           }
           popBtn(dislikeBtn);
         }

         likeCountEl.textContent = optimistic.likes;
         dislikeCountEl.textContent = optimistic.dislikes;
         animCount(action === 'like' ? likeCountEl : dislikeCountEl);
         likeBtn.classList.toggle('is-active', optimistic.myAction === 'like');
         dislikeBtn.classList.toggle('is-active', optimistic.myAction === 'dislike');
         prefetchStore[vid] = optimistic;
         setCache(vid, optimistic);

         apiCall(action, vid, function(data) {
           if (seq !== _engagementSeq) return;

           if (data.shares === undefined) data.shares = prefetchStore[vid] ? (prefetchStore[vid].shares || 0) : 0;
           likeCountEl.textContent = data.likes || 0;
           dislikeCountEl.textContent = data.dislikes || 0;
           likeBtn.classList.toggle('is-active', data.myAction === 'like');
           dislikeBtn.classList.toggle('is-active', data.myAction === 'dislike');
           prefetchStore[vid] = data;
           setCache(vid, data);
         });
       }

       likeBtn.addEventListener('click', function() { optimisticReact('like'); });
       dislikeBtn.addEventListener('click', function() { optimisticReact('dislike'); });

       var _origPlayVideo = playVideo;
       playVideo = function(idx) {
         currentVideoIdx = idx;
         initEngagement();
         _origPlayVideo(idx);
       };
     })();
